module.exports = __webpack_public_path__ + "img/icons8-facebook.7d97c59f.svg";